module.exports = __webpack_public_path__ + "img/house-night.54093304.svg";